module.exports = __webpack_public_path__ + "img/21.b0b8ff59.png";